import { formatMoney as formatTenantMoney } from "helpers/money";
import { normalizeVoucherMoney } from "../../../../services/voucherContract";
import { issuedVoucherStatus } from "../../../vouchers/voucherPresentation";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import PaginationLoader from "component/PaginationLoader";
import { ClientVoucherListViewApi } from "store/slices/clientvoucherSlice";
import config from "../../../../config";
import moment from "moment";
import ApiStatus from "component/ApiStatus";
import { clientDetailId, normalizeClientDetail, readableClientHistoryError } from "../clientDetailUx";
import { voucherOwnershipPresentation } from "./voucherOwnership";

const Voucher = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  void (currentUser && currentUser.role_id);
  useSelector(state => state.salonmodule.isAccess);
  const voucherApiStatus = useSelector((state) => state.clientvoucher.isApiStatus);
  const voucherViews = useSelector((state) => state.clientvoucher.isListView);
  const voucherListError = useSelector((state) => state.clientvoucher.isListViewError);
  const detail = normalizeClientDetail(useSelector((state) => state.client.isDetailData));
  const client_id = clientDetailId(detail);
  // console.log("voucherViews",voucherViews);
  useEffect(() => {
    if (!client_id) return;
    dispatch(ClientVoucherListViewApi({ client_id: client_id }));
  }, [dispatch, client_id]);
  const fetchDataVoucherList = () => {
    if (!client_id || !voucherViews?.next_page_url) return;
    dispatch(ClientVoucherListViewApi({ client_id: client_id, next_page_url: voucherViews.next_page_url }));
  };
  const [isFetching, setIsFetching] = useState(false);
  const loadMoreItemsList = () => {
    if (!client_id) return;
    setIsFetching(true);
    dispatch(ClientVoucherListViewApi({ next_page_url: voucherViews && voucherViews.next_page_url, client_id }));
    //mocking an API call
    setTimeout(() => {
      setIsFetching(false);
    }, 2000);
  };

  return (
    <>
      {voucherListError && <div className="alert alert-danger" role="alert">{readableClientHistoryError(voucherListError, t("Unable to load vouchers."))}</div>}
      {voucherViews && Array.isArray(voucherViews.data) && voucherViews.data.length > 0 ? (
        <InfiniteScroll className="row gx-0" dataLength={voucherViews.data.length} next={fetchDataVoucherList} scrollableTarget="voucherlist" hasMore={voucherViews.next_page_url ? true : false} loader={<PaginationLoader />}>
          {Object.keys(voucherViews.data).map((item, i) => {
            const voucher = voucherViews.data[item] || {};
            const ownership = voucherOwnershipPresentation(voucher);
            let code = voucher.code;
            let expiry_at = voucher.expiry_at ? moment(voucher.expiry_at, 'YYYY-MM-DD HH:mm:ss') : "";
            let issued_at = voucher.created_at ? moment(voucher.created_at, 'YYYY-MM-DD HH:mm:ss') : "";
            const status = issuedVoucherStatus(voucher);
            let amount = voucher.amount ?? voucher.original_value;
            let remaining_balance = voucher.remaining_balance;

            const vDef = voucher.voucher || {};
            const voucher_cost = normalizeVoucherMoney(voucher.purchase_cost);
            let toname = `${voucher.first_name || ""} ${voucher.last_name || ""}`.trim();
            let fromname = voucher.from_name || "";
            const voucher_name = vDef && vDef.name ? vDef.name : "";

            const ServiceVoucher = voucher.service || vDef.service || {};
            return (
              <div className="mb-lg-2" key={item && item.id ? item.id : i}>
                <a className="text-decoration-none event-box-pink client-voucher-card mb-3 cursor-default">
                  <div className="client-voucher-card__head">
                    <h6 className="mb-0 color-wine fw-semibold">{t("Code") + " : " + code}</h6>
                    {status === "Inactive" ? (
                      <span className="btn btn-secondary btn-sm fw-bold p-0 client-voucher-card__status">{t("Inactive")}</span>
                    ) : status === "Redeemed" ? (
                      <span className="btn btn-secondary btn-sm fw-bold p-0 client-voucher-card__status">{t("Redeemed")}</span>
                    ) : status === "Expired" ? (
                      <span className="btn btn-dark btn-sm fw-bold p-0 client-voucher-card__status">{t("Expired")}</span>
                    ) : (
                      <span className="btn btn-primary btn-sm fw-bold p-0 client-voucher-card__status">{t("Active")}</span>
                    )}
                  </div>
                  <div className="client-voucher-card__meta">
                    <h6 className="mb-1" data-assignment-status={ownership.assignmentStatus}>
                      {t(ownership.label)}
                    </h6>
                    {issued_at ? <h6 className="mb-1">{t("Issued {{date}}", { date: issued_at.format("Do MMMM YYYY") })}</h6> : ""}
                    {expiry_at ? <h6 className="mb-1">{t("Expires {{date}}", { date: expiry_at.format("Do MMMM YYYY") })}</h6> : ""}
                  </div>
                  <div className="row">
                    <h6 className="col-md-12 mb-1 client-voucher-card__name">
                      <b>{t("Name")}:</b> {voucher_name}
                    </h6>
                  </div>
                  <div className="row">
                    {/* <h6 className="col-md-6 mb-1">
                        <b>From:</b> Jo Smith
                      </h6> */}
                    {fromname ? (
                      <h6 className="col-md-6 mb-1">
                        <b>{t("From")}:</b> {fromname}
                      </h6>
                    ) : ""}
                    <h6 className="col-md-6 mb-1">
                      <b>{t("To")}:</b> {toname}
                    </h6>
                  </div>
                  <div className="client-voucher-card__amounts">
                    <div className="row align-items-center">
                      <h6 className="col-6 mb-1 client-voucher-card__label">
                        <b>{t("Cost")}</b>
                      </h6>
                      <h6 className="col-6 mb-1 text-end client-voucher-card__value">{voucher_cost === "" ? "—" : `${formatTenantMoney(voucher.purchase_cost, voucher.currency || "AUD")}`}</h6>
                    </div>
                    <div className="row align-items-center">
                      <h6 className="col-6 mb-1 client-voucher-card__label">
                        <b>{t("Initial Value")}</b>
                      </h6>
                      <h6 className="col-6 mb-1 text-end client-voucher-card__value">{formatTenantMoney(amount, voucher.currency || "AUD")}</h6>
                    </div>
                    <div className="row align-items-center">
                      <h6 className="col-6 mb-0 client-voucher-card__label">
                        <b>{t("Balance")}</b>
                      </h6>
                      <h6 className="col-6 mb-0 text-end client-voucher-card__balance">
                        <b>{formatTenantMoney(remaining_balance, voucher.currency || "AUD")}</b>
                      </h6>
                      {ServiceVoucher && ServiceVoucher.name ? (
                        <h6 className="col-md-12 mb-1 mt-2 client-voucher-card__service">
                          {t("Service")}: <b>{` ${ServiceVoucher?.name}`}</b>
                        </h6>
                      ) : ""}
                    </div>
                  </div>
                </a>
              </div>
            );
          })}
          {!isFetching && voucherViews.next_page_url && (
            <div className="col-2 m-auto p-3 text-center">
              <button onClick={loadMoreItemsList} className="btn btn-primary">
                {t("More")}
              </button>
            </div>
          )}
        </InfiniteScroll>
      ) : (
        <>
          {voucherApiStatus &&
            voucherApiStatus.ClientVoucherListViewApi === "loading" ? (
            <ApiStatus actionType="clientvoucherview" />
          ) : (
            <div className="complete-box text-center d-flex flex-column justify-content-center mt-xl-4">
              <div className="complete-box-wrp text-center">
                <img src={config.imagepath + "nots.png"} alt="" className="mb-md-4 mb-3" />
                <h5 className="mb-2 fw-semibold">{t("There are no vouchers available.")}</h5>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Voucher;
